import { calculateRgbaWithAlpha } from 'helpers/colorFormatter';

const NORMAL_ALPHA = 0.08;
const HOVER_ALPHA = 0.3;

const ownCardState = () => ({
  card: theme => {
    const shouldRenderDropShadow = theme.palette.card.dropShadow;
    const boxShadowColor = theme.palette.menuItemNames.main;

    const hoverShadow = `${calculateRgbaWithAlpha(
      boxShadowColor,
      HOVER_ALPHA
    )} 0px 3px 10px 0px, 0px 1px 0px 0px rgba(0,0,0,0.01), 0px 0px 5px 0px rgba(0,0,0,.01)`;

    if (!shouldRenderDropShadow) {
      return {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: hoverShadow,
          bottom: 1
        }
      };
    }

    const dropShadow = `${calculateRgbaWithAlpha(
      boxShadowColor,
      NORMAL_ALPHA
    )} 0px 3px 10px 0px, rgba(0, 0, 0, 0.01) 0px 1px 0px 0px, rgba(0, 0, 0, 0.01) 0px 0px 5px 0px`;

    return {
      boxShadow: dropShadow,
      '&:hover': {
        boxShadow: hoverShadow,
        bottom: 1
      }
    };
  }
});

export default ownCardState;
